import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Paper,
  CircularProgress,
  Box,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { format } from "date-fns";
import { StyledTableCell } from "../../components/styled";
import { DATE_TIME_FORMAT, MATCH_EVENTS_PER_PAGE } from "../../utils/constants";
import { resolveCountryEventDisplay } from "../../utils/worldCupNation";

const MatchEventsTable = ({
  events,
  eventsLoading,
  onEditEvent,
  onDeleteEvent,
  onLoadMore,
  showAddEvent,
  editingEvent,
  isCountryMatch = false,
  homeSide,
  awaySide,
  nationMap,
}) => {
  return (
    <Paper>
      <Table size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell>Time</StyledTableCell>
            <StyledTableCell>
              {isCountryMatch ? "Country" : "Team"}
            </StyledTableCell>
            <StyledTableCell>Type</StyledTableCell>
            <StyledTableCell>Player</StyledTableCell>
            <StyledTableCell>Assist</StyledTableCell>
            <StyledTableCell>Order</StyledTableCell>
            <StyledTableCell>Created At</StyledTableCell>
            <StyledTableCell>Actions</StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {eventsLoading && events.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} align="center">
                <CircularProgress />
              </TableCell>
            </TableRow>
          ) : events.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} align="center">
                No events found
              </TableCell>
            </TableRow>
          ) : (
            events.map((event) => (
              <TableRow key={event.id}>
                <TableCell>{event.time}&apos;</TableCell>

                <TableCell>
                  {isCountryMatch
                    ? resolveCountryEventDisplay(
                        event.country,
                        nationMap,
                        homeSide,
                        awaySide,
                      )
                    : event.team?.name || `Team ${event.teamId}`}
                </TableCell>

                <TableCell>{event.type}</TableCell>

                <TableCell>{event.playerName}</TableCell>

                <TableCell>{event.assistName || "-"}</TableCell>

                <TableCell>{event.order}</TableCell>

                <TableCell>
                  {event.createdAt
                    ? format(new Date(event.createdAt), DATE_TIME_FORMAT)
                    : "N/A"}
                </TableCell>

                <TableCell>
                  <IconButton
                    size="small"
                    onClick={() => onEditEvent(event)}
                    disabled={!!(showAddEvent || editingEvent)}
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => onDeleteEvent(event.id)}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>

      {events.length >= MATCH_EVENTS_PER_PAGE && (
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Button
            variant="outlined"
            onClick={onLoadMore}
            disabled={eventsLoading}
          >
            {eventsLoading ? <CircularProgress size={24} /> : "Load More"}
          </Button>
        </Box>
      )}
    </Paper>
  );
};

export default MatchEventsTable;
